import { Box, DialogContent, DialogTitle } from "@mui/material";
import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { useFormValueChanged } from "../hooks/use-on-form-value-changed";
import { getAddWorkOrderPoFormSchema } from "../schema";
import { mapAddWorkOrderPoModelToAddApiRequest } from "../ultilities/map";

export const AddWorkOrderPo = observer(() => {
  const {
    workOrderPoManagement: { openNew, getWorkOrdersPo, setProp },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<IAddWorkOrderPo>((form) => getAddWorkOrderPoFormSchema(form), {
    date: dateTimeToUTCString(dayjs()),
    woNumber: "",
    customerId: "",
    purchaseOrderId: "",
    note: "",
    dealingNameReadOnlyInfo: "",
    productCodeReadOnlyInfo: "",
    productNameReadOnlyInfo: "",
    productBarcodeReadOnlyInfo: "",
    orderDateReadOnlyInfo: "",
    deliveryDateReadOnlyInfo: "",
    orderAmountReadOnlyInfo: "",
    orderAmountUpperReadOnlyInfo: "",
    orderAmountLowerReadOnlyInfo: "",
    paperTypeReadOnlyInfo: "",
    gsmReadOnlyInfo: "",
    paperBrandReadOnlyInfo: "",
    firstFullPaperLengthReadOnlyInfo: "",
    firstFullPaperSizeReadOnlyInfo: "",
    secondFullPaperLengthReadOnlyInfo: "",
    secondFullPaperSizeReadOnlyInfo: "",
    firstPrintPaperLengthReadOnlyInfo: "",
    firstPrintPaperSizeReadOnlyInfo: "",
    secondPrintPaperLengthReadOnlyInfo: "",
    secondPrintPaperSizeReadOnlyInfo: "",
    poItemProductionAmount: null,
    productionAmount: null,
    poItemFirstFullPaperAmount: null,
    poItemFirstFullPaperLength: null,
    poItemFirstFullPaperSize: null,
    poItemSecondFullPaperAmount: null,
    poItemSecondFullPaperLength: null,
    poItemSecondFullPaperSize: null,
    poItemGSM: null,
  });

  const { onValueChanged } = useFormValueChanged({ getControl });

  const saveHandler = useCallback(
    async (data: IAddWorkOrderPo) => {
      try {
        const req = mapAddWorkOrderPoModelToAddApiRequest(data);
        await workOrderPoBusiness.add(req);
        await getWorkOrdersPo();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getWorkOrdersPo, setProp],
  );

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm lệnh sản xuất</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm
            controls={controls}
            onValueChanged={onValueChanged}
          ></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
